<script setup>
import {onMounted, ref, watch} from "vue";
import Button from "../../components/forms/Button.vue";
import DocumentsListComponent from "../../components/documents/DocumentsListComponent.vue";
import UserService from "../../services/UserService.js";
import {useRoute} from "vue-router";
import router from "@/router";

import {useI18n} from 'vue-i18n'

const {t} = useI18n();

const route = useRoute();

const filterType = ref((route.query && route.query.filter) ? route.query.filter : '');
const isLoading = ref(false);

const filterTypeString = ref('');

onMounted(() => {
  getTypeString(filterType.value);
});

function getTypeString(filterType) {
  if (filterType === 'to-processing') {
    filterTypeString.value = ' - ' + t('documentsIndex.to_processing')
  } else if (filterType === 'in-solution') {
    filterTypeString.value = ' - ' + t('documentsIndex.in_solution')
  } else {
    filterTypeString.value = ' - ' + t('documentsIndex.archived')
  }
}
watch(() => route.query.filter, (newFilter, oldFilter) => {
  if (newFilter !== oldFilter) {
    filterType.value = newFilter;
    getTypeString(filterType.value);
  }
});
</script>

<template>

  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-2">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('documentsIndex.back') }}</a>
        </div>
        <div class="col-8 text-center">
          <div class="page-section__title">
            {{ t('documentsIndex.documents') }} {{ filterTypeString }}
          </div>
        </div>
      </div>
    </div>
    <div class="page-section__content">
      <DocumentsListComponent :key="filterType" :filterType="filterType"/>
    </div>
  </div>


</template>

<style scoped>

</style>
